import React from 'react';
import { motion } from 'framer-motion';
import { ParticleBackground } from './ParticleBackground';
import { CTAButton } from './CTAButton';
import { CountdownTimer } from './CountdownTimer';
import { Check } from 'lucide-react';
export function FinalCTASection() {
  return <section className="relative py-24 px-4 bg-dark-bg-alt overflow-hidden" data-id="element-87">
      <ParticleBackground data-id="element-88" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-89">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl font-display font-bold text-white mb-8" data-id="element-90">
          Tu Viaje de Sanación <br data-id="element-91" />
          <span className="gradient-text-violet" data-id="element-92">Comienza Ahora</span>
        </motion.h2>

        <p className="text-xl text-gray-300 mb-12 leading-relaxed max-w-2xl mx-auto" data-id="element-93">
          No dejes pasar esta oportunidad de transformar tu energía y tu vida.
          El conocimiento está a tu alcance, solo tenés que dar el primer paso.
        </p>

        <div className="bg-dark-surface/50 backdrop-blur-sm border border-violet-500/30 rounded-2xl p-8 mb-12 inline-block text-left" data-id="element-94">
          <h3 className="text-white font-bold mb-4 text-lg" data-id="element-95">
            Resumen de lo que te llevás:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-3" data-id="element-96">
            {['Curso Completo Nivel 1, 2 y Maestría', 'Manuales y Guías PDF', 'Audios y Meditaciones', 'Certificación Personalizable', '5 Bonus Exclusivos', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-center gap-2 text-gray-300" data-id="element-97">
                <Check className="w-4 h-4 text-green-400" data-id="element-98" />
                <span data-id="element-99">{item}</span>
              </div>)}
          </div>
        </div>

        <div className="mb-8" data-id="element-100">
          <div className="text-5xl md:text-7xl font-bold text-white mb-2 animate-text-glow" data-id="element-101">
            $19.990
          </div>
          <CountdownTimer data-id="element-102" />
        </div>

        <CTAButton text="¡SÍ, ESTOY LISTO/A PARA MI TRANSFORMACIÓN!" size="xl" className="w-full md:w-auto mb-8" data-id="element-103" />

        <p className="text-sm text-gray-400 max-w-xl mx-auto mb-16" data-id="element-104">
          P.D.: Recordá que esta oferta es por tiempo limitado. Cada minuto que
          pasa es un minuto menos para acceder a este precio especial.
        </p>

        <footer className="border-t border-white/10 pt-8 text-xs text-gray-500" data-id="element-105">
          <p className="mb-2" data-id="element-106">
            Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
          <p data-id="element-107">
            Copyright © {new Date().getFullYear()} Reiki MegaPack. Todos los
            derechos reservados.
          </p>
        </footer>
      </div>
    </section>;
}